import { tsrContractsClient } from '../tsrContractsClient';

export const patientConsultationsClient = () => tsrContractsClient.consultationContract;
